// Converted from application/views/sculptures/seven-veils_v.php. Edit this component directly.
export default function SculpturesSevenVeilsPage() {
  return <><div class={"firstContainer container photoLeft"}>
<figure class={"photo"}>
<img src={"/assets/images/sculptures/seven-veils/Seven-Veils-gold.jpg"} alt={"Seven Veils"} />
<figcaption>{"#1"}</figcaption>
</figure>
<div class={"text"}>
<div>
<div class={"mainTitleWrp"}>
<h1>{"Seven Veils "}<small>{"(L)"}</small></h1>
<p>
<b>{"92 x 92 x 170 cm"}</b><br />{"\n                        36.2” x 36.2” x 67”"}<br />{"\n                        Bronze"}<br />{"\n                        No. in Series 6\n                "}</p>
</div>
</div>
</div>
</div>
<div class={"container photoRight"}>
<div class={"text"}>
<div>
<p>{"\n                Margaretha MacLeod, better known by her stage name “Mata Hari” (Indonesian for “Eye of the Dawn”) was a Dutch exotic dancer and courtesan who was convicted of being a spy for Germany during World Was 1, and was executed by firing squad in France in 1917.\n            "}</p>
<p>{"\n                She had entertained the French and German troops, in turn, as the Battle lines moved to and fro, her “piece-de-resistance” being the dance of the "}<b>{"Seven Veils"}</b>{".  Her seemingly glamorous life was in fact full of drama and loss.  Her marriage had broken up, she had lost her two children, and she had been accused of sleeping with generals on both sides and swapping war secrets in bed.\n            "}</p>
</div>
</div>
<figure class={"photo"}>
<img src={"/assets/images/sculptures/seven-veils/seven-veils-back.jpg"} alt={"Seven Veils Closeup"} />
<figcaption>{"#2"}</figcaption>
</figure>
</div>
<div class={"container photoLeft"}>
<figure class={"photo"}>
<img src={"/assets/images/sculptures/seven-veils/seven-veils-closeup2.jpg"} alt={"Seven Veils Closeup"} />
<figcaption>{"#3"}</figcaption>
</figure>
<div class={"text"}>
<div>
<p>{"\n                Although she was later found to have been a scapegoat for the incompetence of the generals, Mata Hari died defiantly in a hail of bullets, blowing a kiss to the firing squad.\n            "}</p>
<p>{"\n                My sculpture seeks to capture that moment, dancing to liberation in the cross hairs between life and death.\n            "}</p>
<p>{"\n                Disowned by her family, her body vanished.  I felt compelled to make this sculpture as a resting place for her spirit.\n            "}</p>
</div>
</div>
</div>
<div class={"container photoLeft"}>
<div class={"text"}>
<div>
<p>{"\n                Although I used a live model for the pose, I spent long days and hours, alone, struggling to keep it together.  Later, I fought to save the wax from softening as I worked in one of the hottest summers I had experienced in Florence.\n    \n            "}</p>
<p>{"\n                Somehow I felt that Mata Hari wanted me to keep going.  This was an extraordinary experience for me, as an artist, but I have never regretted allowing her to finish her dance of the "}<b>{"SEVEN VEILS"}</b>{".\n            "}</p>
</div>
</div>
<figure class={"photo"}>
<img src={"/assets/images/sculptures/seven-veils/seven-veils-closeup.jpg"} alt={"Seven Veils Closeup"} />
<figcaption>{"#4"}</figcaption>
</figure>
</div>
</>;
}
